import { CloseButton, TextInput } from "@mantine/core";

import type { PracticeLedgerSearchOption } from "@/billing/types/practice-ledger";
import MultiSearchInputWrapper from "@/components/MultiSearchInputWrapper";

import {
  CLEAR_SEARCH_LABEL,
  SEARCH_BAR_WIDTH,
  SEARCH_LABEL,
  SEARCH_OPTIONS,
  SEARCH_PLACEHOLDERS,
} from "./constants/practice-ledger";
import type { PracticeLedgerSearchControlProps } from "./types/ledger-ui";

export default function LedgerSearch({
  query,
  onQueryChange,
  searchOption,
  onSearchOptionChange,
}: PracticeLedgerSearchControlProps) {
  return (
    <MultiSearchInputWrapper
      wrap="nowrap"
      label={SEARCH_LABEL}
      selected={searchOption}
      options={SEARCH_OPTIONS}
      w={{ base: "100%", sm: SEARCH_BAR_WIDTH }}
      menuTargetTestId="practice-ledger-search-option"
      onChangeOption={(option) => onSearchOptionChange(option as PracticeLedgerSearchOption)}
    >
      <TextInput
        w="100%"
        value={query}
        data-testid="practice-ledger-search"
        placeholder={SEARCH_PLACEHOLDERS[searchOption]}
        onChange={(event) => onQueryChange(event.currentTarget.value)}
        rightSection={
          query ? (
            <CloseButton
              size="sm"
              aria-label={CLEAR_SEARCH_LABEL}
              onClick={() => onQueryChange("")}
              data-testid="practice-ledger-search-clear"
            />
          ) : null
        }
      />
    </MultiSearchInputWrapper>
  );
}
